define('GameDayCore/GDControl/advertising/MidInningGamesManager',['require','exports','module','../../GDModel/load/execute/FileRequestItem','../../GDModel/storage/ModelCache','../GameModelLocator/GameModelLocator','data-fetcher/data-fetcher','../../GDModel/enums/datasources/Datasources','../../GDUtil/window/WindowBridge','message-service/message-service','../../GDModel/enums/events/EventTypes','../../GDUtil/window/Logg','extant/extant'],function(require,exports,module) {
    var FileRequestItem = require("../../GDModel/load/execute/FileRequestItem"),
        ModelCache = require("../../GDModel/storage/ModelCache"),
        GameModelLocator = require('../GameModelLocator/GameModelLocator'),
        dataFetcher = require("data-fetcher/data-fetcher"),
        Datasources = require("../../GDModel/enums/datasources/Datasources"),
        WindowBridge = require("../../GDUtil/window/WindowBridge"),
        MessageService = require("message-service/message-service"),
        EventTypes = require("../../GDModel/enums/events/EventTypes"),
        logg = require("../../GDUtil/window/Logg"),
        exists = require("extant/extant"),
        initialized = false,
        currentGame;

    function maybeDisplayMidInningGame() {
        if (!initialized){
            return false;
        }
        logg.log("MidInningGameManager : maybeDisplayMidInningGame");

        //check if any games match the current game situation
        var rsrc = Datasources.MID_INNING_GAMES,
            activeMIG = GameModelLocator.getGameData(rsrc)[rsrc];

        if (!exists(activeMIG,'slot')) {
            return false;
        }
        // let the requester know what's up
        return true;
    }

        // get this party started
    exports.init = function() {
        // get the static Resources info from the model.
        var rsrcs = Datasources.STATIC_RESOURCES,
            config = GameModelLocator.getGameData(rsrcs)[rsrcs],
            that = this;

        if (!exists(config)) {
            MessageService.one(EventTypes.UPDATE, function() {
                that.init();
            });

            return;
        }

        // disabled? then bail
        if (!config.midInningGamesEnabled) {
            logg.log("mid-inning games disabled");
            return;
        }


        currentGame = GameModelLocator.getCurrentGame();
        var url = config.getMidInningGamesXmlUrl,
            datasrc = Datasources.MID_INNING_GAMES,
            gameParams = currentGame.addGameParams({ urlPath: url });

        logg.log("GET: mid inning game deets");
        dataFetcher.get(new FileRequestItem(datasrc, true, gameParams, handleMigDataLoad));

        function handleMigDataLoad(res) {
            if (!exists(res.data)) {
                logg.log("there was no data inside the mid-inning game Load");
                return;
            }
            // not sure i want to store this there
            ModelCache.storeGameData(res.params.gid, res, (new Date()).getTime());
            initialized = true;
        }
    };

    exports.checkMidInningGames = function () {
        return maybeDisplayMidInningGame();
    }
});
